import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import outfitBold from '@/assets/fonts/Outfit-Bold.woff2?url';
import outfitRegular from '@/assets/fonts/Outfit-Regular.woff2?url';

import { App } from './App';
import './styles/globals.css';

/**
 * Preload the two self-hosted Outfit faces (CONVENTIONS.md §4.5).
 *
 * The links are injected here rather than written into index.html because
 * only the bundler knows the content-hashed filenames of the emitted woff2
 * assets; importing them with `?url` is what makes the same code correct in
 * dev and in a production build. No CDN is involved at any point.
 */
function preloadFonts(): void {
  for (const href of [outfitRegular, outfitBold]) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.href = href;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }
}

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root container #root is missing from index.html');
}

preloadFonts();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
